export const pages = {
  dashboard: '/dashboard',
  connect: '/connect',
  /* Campaign pages (legacy) */
  campaigns: '/campaigns',
  campaignDetail: '/campaigns/:campaignId',
  newCampaign: '/campaigns/create',
  /* Listening Topics */
  listeningTopics: '/topics',
  /* Merged pages */
  analytics: '/analytics',
  accounts: '/accounts',
  posts: '/posts-manage',
  settings: '/settings',
  subscription: '/subscription',
  subscription_callback: '/subscription/cb',
  signup: 'http://localhost:8001/oauth2/cb', // TODO: Replace with correct signup URL
  logout: 'https://app.nalapod.com/logout',
  oauth: {
    redditCode: '/reddit/code',
    instagramCode: '/instagram/code',
    tiktokCode: '/tiktok/code',
    youtubeCode: '/youtube/code',
  },
  privacy: '/privacy',
  terms: '/termsandconditions',
  post: '/post',
  userPosts: '/posts',
  profile: '/profile',
  trends: '/trends',
  target: {
    intro: '/target',
    creators: '/target/creators',
    followers: '/target/followers',
  },
  automations: '/automations',
  automationsInstagram: '/automations/instagram',
  automationsYoutube: '/automations/youtube',
  createAutomation: '/automations/create',
  popularity: '/popularity',
  socialcards: '/socialcards',
  socialcomments: '/socialcomments',
  postdetails: '/postdetails',
  followerslist: '/followerslist',
  allAnalytics: '/interactions',
  connectedAccounts: '/connected-accounts',
  followerAnalytics: '/followers',
  discoverContent: '/discover',
  superFans: '/super-fans',
  admin: '/admin',
} as const
